import { z } from "zod";

export const OAUTH_FRAME_DATA_SOURCE = "inference";

export const OAuthProvider = z.enum(["GOOGLE", "GITHUB"]);

export type OAuthProviderType = z.infer<typeof OAuthProvider>;
